import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { fontNormal, spacing, smallDevices, fontSmall, borderRadius, gray70, white, gray50, gray80, black, gray95, actionColor } from '@propellerads/stylevariables';
import Currency from '@propellerads/currency';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { showTooltip, TOOLTIP_POSITION, hideTooltip } from '@propellerads/smart-tooltip';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    z-index: 99;\n    padding: ", "px;\n    position: fixed;\n    left: 0 !important;\n    top: 56px;\n    right: 0 !important;\n    \n    ", ";\n\n    @media (min-width: ", "px) {\n        width: initial;\n        position: absolute;\n        top: 100%;\n        left: initial !important;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-left: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background: transparent;\n    border: 0;\n    margin: 0;\n    outline: none;\n    font-size: ", "px;\n    display: flex;\n    align-items: center;\n    padding: 0 ", "px;\n    height: 100%;\n    cursor: pointer;\n    color: ", ";\n    \n    &:hover {\n        color: ", ";\n\n        & > svg{\n          fill: ", ";\n        }\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    display: flex;\n    height: 100%;\n    align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeaderItem = styled.div(_templateObject());
var StyledHeaderItemButton = styled.button(_templateObject2(), fontNormal, spacing * 4, function (props) {
  return props.theme.header.menuItemColor;
}, function (props) {
  return props.theme.header.menuItemColorHover;
}, function (props) {
  return props.theme.header.menuItemColorHover;
});
var StyledHeaderItemTitle = styled.div(_templateObject3(), spacing);
var StyledHeaderItemDropdown = styled.div(_templateObject4(), spacing, function (props) {
  return props.isRightDropdown && "\n        left: ".concat(props.isRightDropdown ? 'initial' : 0, ";\n        right: ").concat(props.isRightDropdown ? 0 : 'initial', ";\n    ");
}, smallDevices);

function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

var HeaderItem = function HeaderItem(_ref) {
  var id = _ref.id,
      children = _ref.children,
      isRightDropdown = _ref.isRightDropdown,
      icon = _ref.icon,
      title = _ref.title,
      _onClick = _ref.onClick,
      component = _ref.component;
  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowDropdown = _useState2[0],
      setDropdown = _useState2[1];

  var titleComponent = title && /*#__PURE__*/React.createElement(StyledHeaderItemTitle, null, title);
  useOnClickOutside(ref, function () {
    return setDropdown(false);
  });
  return /*#__PURE__*/React.createElement(StyledHeaderItem, {
    id: id,
    ref: ref
  }, /*#__PURE__*/React.createElement(StyledHeaderItemButton, {
    type: "button",
    onClick: function onClick() {
      if (_onClick && typeof _onClick === 'function') {
        _onClick();

        return;
      }

      setDropdown(!isShowDropdown);
    }
  }, icon && icon, titleComponent, component && component, children && isShowDropdown && /*#__PURE__*/React.createElement(StyledHeaderItemDropdown, {
    isRightDropdown: isRightDropdown,
    onClick: function onClick() {
      return setDropdown(false);
    }
  }, children)));
};

HeaderItem.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  component: PropTypes.element,
  icon: PropTypes.node,
  title: PropTypes.string,
  isRightDropdown: PropTypes.bool
};
HeaderItem.defaultProps = {
  id: undefined,
  children: undefined,
  onClick: undefined,
  component: undefined,
  title: undefined,
  icon: undefined,
  isRightDropdown: false
};

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: ", ";\n    background-color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    flex: 0 0 7px;\n    border: solid transparent;\n    border-width: 0 1px;\n    opacity: 0.3;\n\n    &:hover {\n        opacity: 1;\n        ", " {\n            opacity: 1;\n        }\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n    opacity: 0;\n    position: absolute;\n    top: calc(-100% - 2px);\n    left: 0;\n    display: block;\n    padding: 0 3px;\n    font-size: ", "px;\n    line-height: 16px;\n    border-radius: ", "px;\n    white-space: nowrap;\n    pointer-events: none;\n    color: ", ";\n    background-color: ", ";\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 8px;\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    width: 49px;\n    flex: 0 0 49px;\n    height: 16px;\n    cursor: default;\n\n    @media (max-width: ", "px) {\n        display: none;\n    }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 ", "px;\n    line-height: 1.14;\n    letter-spacing: 0.3px;\n    font-size: ", "px;\n    display: flex;\n    font-weight: bold;\n    color: ", ";\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    padding: ", "px 0;\n    z-index: 1;\n    color: ", ";\n    background-color: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeaderBalance = styled.div(_templateObject$1(), spacing * 2, function (props) {
  return props.theme.balance.textColor;
}, function (props) {
  return props.theme.header.backgroundColor;
});
var StyledHeaderBalanceValue = styled.div(_templateObject2$1(), spacing * 2, fontNormal, function (props) {
  return props.theme.balance.textColor;
});
var StyledHeaderBalanceDailyEarned = styled.div(_templateObject3$1(), smallDevices);
var StyledHeaderBalanceChartDay = styled.span(_templateObject4$1(), fontSmall, borderRadius, function (props) {
  return props.theme.balance.chartColor;
}, function (props) {
  return props.theme.balance.chartBackgroundColor;
});
var StyledHeaderBalanceChart = styled.div(_templateObject5(), StyledHeaderBalanceChartDay);
var StyledHeaderBalanceChartValue = styled.div(_templateObject6(), function (props) {
  return props.percentage > 1 ? "".concat(props.percentage, "%") : '1px';
}, function (props) {
  return props.theme.balance.dailyEarnedColor;
});

var HeaderBalanceChart = function HeaderBalanceChart(_ref) {
  var day = _ref.day;
  var date = day.date,
      value = day.value,
      percentage = day.percentage;
  return /*#__PURE__*/React.createElement(StyledHeaderBalanceChart, null, /*#__PURE__*/React.createElement(StyledHeaderBalanceChartValue, {
    percentage: percentage
  }), /*#__PURE__*/React.createElement(StyledHeaderBalanceChartDay, null, date, ' ', "-", ' ', /*#__PURE__*/React.createElement(Currency, {
    value: value
  })));
};

HeaderBalanceChart.propTypes = {
  day: PropTypes.shape({
    date: PropTypes.node,
    value: PropTypes.node,
    percentage: PropTypes.node
  }).isRequired
};

var HeaderBalance = function HeaderBalance(_ref2) {
  var balance = _ref2.balance,
      dailyEarned = _ref2.dailyEarned;
  var dailyEarnedExist = Boolean(dailyEarned.length);
  return /*#__PURE__*/React.createElement(StyledHeaderBalance, null, /*#__PURE__*/React.createElement(StyledHeaderBalanceValue, null, /*#__PURE__*/React.createElement(Currency, {
    value: balance,
    decimalPosition: 2
  })), dailyEarnedExist && /*#__PURE__*/React.createElement(StyledHeaderBalanceDailyEarned, null, dailyEarned.map(function (day, idx) {
    return /*#__PURE__*/React.createElement(HeaderBalanceChart, {
      key: idx,
      day: day
    });
  })));
};

HeaderBalance.propTypes = {
  balance: PropTypes.number.isRequired,
  dailyEarned: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired
  }))
};
HeaderBalance.defaultProps = {
  dailyEarned: []
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 0 ", "px;\n    cursor: default;\n    color: ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeaderTime = styled.div(_templateObject$2(), spacing * 4, function (props) {
  return props.theme.header.menuItemColor;
});

dayjs.extend(utc);

function getTime() {
  var utcTime = dayjs.utc();
  return utcTime.subtract(5, 'hour');
}

var HeaderTime = function HeaderTime(_ref) {
  var tooltipContent = _ref.tooltipContent;

  var _useState = useState(getTime()),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  var savedCallback = useRef();

  savedCallback.current = function () {
    setTime(getTime());
  };

  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    var timer = setInterval(tick, 1000);
    return function () {
      return clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledHeaderTime, {
    onMouseEnter: function onMouseEnter(e) {
      showTooltip(e.target, tooltipContent(time), TOOLTIP_POSITION.BOTTOM);
    },
    onMouseLeave: hideTooltip
  }, "".concat(time.format('HH:mm'), " (EST)"));
};

HeaderTime.propTypes = {
  tooltipContent: PropTypes.func
};
HeaderTime.defaultProps = {
  tooltipContent: function tooltipContent(ESTDate) {
    return "System time: ".concat(ESTDate.format('HH:mm DD.MM'), " (EST)");
  }
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    width: 1px;\n    height: 20px;\n    background-color: ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeaderDivider = styled.div(_templateObject$3(), function (props) {
  return props.theme.header.dividerColor;
});

var HeaderDivider = function HeaderDivider() {
  return /*#__PURE__*/React.createElement(StyledHeaderDivider, null);
};

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", "px;\n    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n    padding: ", "px 0;\n    width: 100%;\n    background-color: ", ";\n    \n    @media (min-width: ", "px) {\n        width: auto;\n        min-width: 150px;\n    }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeaderDropdown = styled.div(_templateObject$4(), borderRadius, spacing * 2, function (props) {
  return props.theme.header.menuItemBackgroundColor;
}, smallDevices);

var HeaderDropdown = function HeaderDropdown(_ref) {
  var id = _ref.id,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledHeaderDropdown, {
    id: id
  }, children);
};

HeaderDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string
};
HeaderDropdown.defaultProps = {
  id: undefined
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    height: 48px;\n    padding: 0 16px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    text-align: left;\n    background-color: ", ";\n    color: ", ";\n    \n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    & > * {\n        border: 0;\n        margin: 0;\n        color: inherit !important;\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        padding: 0 ", "px;\n        outline: none;\n        font-size: inherit;\n        background: transparent;\n        transition: color 200ms ease-out;\n        text-decoration: none;\n    }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeaderDropdownItem = styled.div(_templateObject$5(), function (props) {
  return props.theme.header.menuItemBackgroundColor;
}, function (props) {
  return props.theme.header.menuItemColor;
}, function (props) {
  return props.theme.header.menuItemBackgroundColorHover;
}, function (props) {
  return props.theme.header.menuItemColorHover;
}, spacing * 4);

var HeaderDropdownItem = function HeaderDropdownItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement(StyledHeaderDropdownItem, null, item);
};

HeaderDropdownItem.propTypes = {
  item: PropTypes.shape({})
};
HeaderDropdownItem.defaultProps = {
  item: {}
};

var HeaderDropdownList = function HeaderDropdownList(_ref2) {
  var items = _ref2.items;
  return items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(HeaderDropdownItem, {
      key: idx,
      idx: idx,
      item: item
    });
  });
};

HeaderDropdownList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({}))
};
HeaderDropdownList.defaultProps = {
  items: []
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    height: 100%;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    height: 56px;\n    align-items: center;\n    justify-content: space-between;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 2001;\n    background-color: ", ";\n    box-shadow: ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeader = styled.div(_templateObject$6(), function (props) {
  return props.theme.header.backgroundColor;
}, function (props) {
  return props.theme.header.boxShadow;
});
var StyledHeaderBrand = styled.div(_templateObject2$2());
var StyledHeaderOptions = styled.div(_templateObject3$2());

var themes = {
  dark: {
    name: 'dark',
    header: {
      backgroundColor: 'hsl(228, 16.9%, 17.5%)',
      color: gray70,
      colorHover: white,
      boxShadow: '0 2px 8px 0 hsla(0, 0%, 0%, 0.1)',
      dividerColor: gray50,
      menuItemColor: gray70,
      menuItemColorHover: white,
      menuItemBackgroundColor: 'hsl(228, 16.9%, 17.5%)',
      menuItemBackgroundColorHover: 'hsla(0, 0%, 0%, 0.3)'
    },
    balance: {
      borderColor: gray80,
      textColor: white,
      dailyEarnedColor: white,
      chartColor: black,
      chartBackgroundColor: white
    }
  },
  light: {
    name: 'light',
    header: {
      backgroundColor: white,
      color: gray70,
      colorHover: black,
      boxShadow: '0 2px 8px 0 hsla(0, 0%, 0%, 0.1)',
      dividerColor: gray95,
      menuItemColor: gray70,
      menuItemColorHover: black,
      menuItemBackgroundColor: white,
      menuItemBackgroundColorHover: gray95
    },
    balance: {
      borderColor: gray80,
      textColor: actionColor,
      dailyEarnedColor: actionColor,
      chartColor: white,
      chartBackgroundColor: black
    }
  }
};

var themeProps = PropTypes.shape({
  name: PropTypes.string,
  header: PropTypes.shape({
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    colorHover: PropTypes.string,
    boxShadow: PropTypes.string,
    dividerColor: PropTypes.string,
    menuItemColor: PropTypes.string,
    menuItemColorHover: PropTypes.string,
    menuItemBackgroundColor: PropTypes.string,
    menuItemBackgroundColorHover: PropTypes.string
  }),
  balance: PropTypes.shape({
    borderColor: PropTypes.string,
    textColor: PropTypes.string,
    dailyEarnedColor: PropTypes.string,
    chartColor: PropTypes.string,
    chartBackgroundColor: PropTypes.string
  })
});
var ThemeContextProvider = function ThemeContextProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};
ThemeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: themeProps
};
ThemeContextProvider.defaultProps = {
  theme: themes.light
};

var themes$1 = themes;

var Header = function Header(_ref) {
  var logo = _ref.logo,
      sidebarButton = _ref.sidebarButton,
      children = _ref.children,
      theme = _ref.theme,
      id = _ref.id;
  return /*#__PURE__*/React.createElement(ThemeContextProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(StyledHeader, {
    id: id
  }, /*#__PURE__*/React.createElement(StyledHeaderBrand, null, sidebarButton, logo), /*#__PURE__*/React.createElement(StyledHeaderOptions, null, children)));
};

Header.propTypes = {
  logo: PropTypes.element.isRequired,
  sidebarButton: PropTypes.element,
  children: PropTypes.node.isRequired,
  theme: themeProps,
  id: PropTypes.string
};
Header.defaultProps = {
  sidebarButton: null,
  theme: themes$1.light,
  id: 'header-container'
};
Header.HeaderItem = HeaderItem;
Header.HeaderBalance = HeaderBalance;
Header.HeaderTime = HeaderTime;
Header.HeaderDivider = HeaderDivider;
Header.HeaderDropdown = HeaderDropdown;
Header.HeaderDropdownList = HeaderDropdownList;

export default Header;
export { themes$1 as themes };
